module.exports = __webpack_public_path__ + "public/img/ship_bg.a2c2bf81.png";